import { useQuery } from '@tanstack/react-query';
import { API_CLIENT } from '../api-new';

export const useOrders = () => {
  return useQuery({
    queryKey: ['orders'],
    queryFn: () => API_CLIENT.list_orders(),
  });
};
